export const ParkingActionTypes = {
  SET_PARKINGS: 'SET_PARKINGS',
  SET_PARKING: 'SET_PARKING',
};
